import SchoolInformationEdit from './SchoolInformationEdit.page';

export default SchoolInformationEdit;
